import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useEffect, useRef } from "react";
import { WITH_APP } from "./PaymentMethod";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  Heading,
} from "@ogt/ui";

export default function PaymentWithApp() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 40;
  // Reset specific fields if the selected compensation is not WITH_APP
  useEffect(() => {
    if (formData.paymentmethod === WITH_APP) {
      setFormData((prev) => ({
        ...prev,
        cardnumber: "",
      }));
    }
  }, [formData.compensation, setFormData]);

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/ersattning-for");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          phonenumberapp: Yup.string().required(
            "Vänligen fyll i ditt telefonnummer"
          ),
          ticketnumber: Yup.string()
            .required("Vänligen fyll i ditt biljett-ID")
            .min(7, "Biljett-ID måste innehålla 7 tecken"),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading progress={progress} headingRef={h2Ref} focusable>
                  Jag hade biljetten i appen
                </Heading>

                <p>
                  För att gå vidare behöver vi ha ditt mobilnummer och ditt
                  biljett-ID.
                </p>
                <p>
                  För att hitta biljett-ID trycker du fram din biljett i appen.
                  Klicka på menyn (de tre prickarna uppe till höger) och välj
                  ”Se biljettdetaljer”.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="phonenumberapp"
                  label={
                    <>
                      Mitt mobilnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="tel"
                  autocomplete={"off"}
                  numbersOnly
                />

                <InputText
                  name="ticketnumber"
                  label={
                    <>
                      Biljett-ID <span>(Obligatoriskt)</span>
                    </>
                  }
                  moreinfo="7 tecken"
                  type="text"
                  autocomplete={"off"}
                  maxLength={7}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
